/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ClientProfileType = {
    Person: 1,
    Organization: 2
} as const;
export type ClientProfileType = typeof ClientProfileType[keyof typeof ClientProfileType];

